module.exports = __webpack_public_path__ + "img/link-faq-mobile_en.acd3add.jpg";